import React, { useState } from 'react';

import PropTypes from 'prop-types';
import RatingDown from 'app/employer/vectors/rating/RatingDown';
import RatingUnsure from 'app/employer/vectors/rating/RatingUnsure';
import RatingUp from 'app/employer/vectors/rating/RatingUp';

// If there is a size prop, returns a new object that translates the size value to height and width properties

const expandSizeProp = (props = {}) => {
   const { size, ...rest } = props;
   const expandedProps = { ...rest };

   if (size) {
      expandedProps.width = size;
      expandedProps.height = size;
   }

   return expandedProps;
};

const mergeProps = (props = {}, parentProps = {}, customClassName) => {
   const { size: propSize, ...restProps } = props;
   const { size: parentPropSize, ...restParentProps } = parentProps;

   let size;

   if (propSize) {
      size = propSize;
   } else if (parentPropSize) {
      size = parentPropSize;
   }

   const mergedProps = { ...restParentProps, ...restProps };

   if (size) {
      mergedProps.height = size;
      mergedProps.width = size;
   }

   if (!mergedProps.className && customClassName) {
      mergedProps.className = customClassName;
   } else if (mergedProps.className && customClassName) {
      mergedProps.className = `${ mergedProps.className } ${ customClassName }`;
   }
   return mergedProps;
};

const ButtonsRating = ({
   containerProps,
   ratingProps,
   ratingUpProps,
   ratingUnsureProps,
   ratingDownProps,
   active,
   handleRateUp,
   handleRateUnsure,
   handleRateDown,
   isUnsureVisible,
}) => {
   const [modContainerProps] = useState(expandSizeProp(containerProps));

   const [modRatingUpProps] = useState(mergeProps(ratingUpProps, ratingProps, 'rating rating-up'));
   const [modRatingUnsureProps] = useState(mergeProps(ratingUnsureProps, ratingProps, 'rating rating-unsure'));
   const [modRatingDownProps] = useState(mergeProps(ratingDownProps, ratingProps, 'rating rating-down'));

   return (
      <div {...(modContainerProps)} style={{ height: '32px' }}>
         <div className='align-self-end'>
            <RatingDown
               {...(modRatingDownProps)}
               className={ `${ modRatingDownProps.className }${ active === 'down' ? ' active' : '' }`}
               onClick={handleRateDown}
            />
         </div>
         {
            isUnsureVisible
            && (
               <RatingUnsure
                  {...(modRatingUnsureProps)}
                  className={`align-self-center ${ modRatingUnsureProps.className }${ active === 'unsure' ? ' active' : '' }`}
                  onClick={handleRateUnsure}
                  width={30}
               />
            )
         }
         <div className='align-self-start'>
            <RatingUp
               {...(modRatingUpProps)}
               onClick={handleRateUp}
               className={`${ modRatingUpProps.className }${ active === 'up' ? ' active' : '' }`}
            />
         </div>
      </div>
   );
};

ButtonsRating.propTypes = {
   containerProps: PropTypes.object,
   ratingProps: PropTypes.object,
   ratingUpProps: PropTypes.object,
   ratingUnsureProps: PropTypes.object,
   ratingDownProps: PropTypes.object,

   active: PropTypes.string, // "up" OR "unsure" OR "down"
   handleRateUp: PropTypes.func,
   handleRateUnsure: PropTypes.func,
   handleRateDown: PropTypes.func,
   isUnsureVisible: PropTypes.bool,
};

ButtonsRating.defaultProps = {
   containerProps: {},
   ratingProps: {},
   ratingUpProps: {},
   ratingUnsureProps: {},
   ratingDownProps: {},
   active: undefined,
   handleRateUp: null,
   handleRateUnsure: null,
   handleRateDown: null,
   isUnsureVisible: true,
};

export default ButtonsRating;
